﻿import $ from "jquery";
import bootbox from 'bootbox';
import { showMessage } from "./main";

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "forumIndex") return;

	$('.btn-link[aria-expanded="true"]').closest('.accordion-item').addClass('active');
	$('.collapse').on('show.bs.collapse', function () {
		$(this).closest('.accordion-item').addClass('active');
	});

	$('.collapse').on('hidden.bs.collapse', function () {
		$(this).closest('.accordion-item').removeClass('active');
	});

});

